<!-- THUMB SIDEBAR -->
@if ((pageContexts.length*2) != loadedThumbCounter + proceededImageCount) {
<div
  id="fullscreenOverlay"
  style="display: block; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.8); z-index: 2000;"
>
  <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white;">
    <div
      id="preloader"
      style="width: 50vw"
      class="mx-auto mt-5"
    >
      <!--  <span>Load : {{this.loadedThumbCounter + proceededImageCount}} / {{pageContexts.length * 2}}</span> -->
      <div class="progress">
        <div
          class="progress-bar"
          role="progressbar"
          style="background-color:#34588C"
          [style.width.%]="(this.loadedThumbCounter+proceededImageCount) / (pageContexts.length *2)   *100"
          aria-valuenow="0"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  </div>
</div>
}

<div
  id="pagesThumbs"
  style="background-color: #FFFFFF;width:125px; position: fixed; display: inline-block;z-index:1033; overflow:auto;left:0px;border-right: 1px solid #c0c0c0;"
  [ngStyle]="{'padding-bottom': editAreaVisible? '420px' : '150px'}"
  appHeightWatcher
>
  <div
    style="background-color: rgb(255, 255, 255); height: 50px;position: fixed;width:125px;z-index:9999;border-bottom:1px solid #DEE2E2;border-right: 1px solid #DEE2E2;"
  >
    <div
      class="btn btn-sm  mx-2 mt-1 d-block"
      [ngStyle]="{
      'background-color': layoutService.activeColor.backgroundColor ,
      'top': this.layoutService.headerHeightInt + 'px',
      'z-index': 1033,
      }"
      (click)="this.closeEditor()"
    ><i class="ri-arrow-left-line"></i></div>
  </div>
  @for (item of counter(selectedDocObject.metadata.pagescount).fill(0); track item; let i = $index) {
  <div
    style="background-color:white; position: relative;top:50px"
    class="m-2 cursor-pointer"
    [ngClass]="{
      'border-selected': i == this._currentPage,
      'border-unselected': i !== this._currentPage
      }"
    (click)="this.scrollTo(i)"
  >
    <!--THUMB-->
    <img
      (load)="this.thumbLoaded(i)"
      [alt]="'Page Thumbnail !!'"
      [id]="selectedDocObject._id + '_' +i"
      [src]="this.getPagePreviewUrl(selectedDocObject._id, i, pageContexts[i].timeblockid, pageContexts[i].participantid) | secure | async"
      class="w-100"
    >
  </div>
  }
</div>
<!-- END THUMB SIDEBAR-->
<div appHeightWatcher>
  @if (selectedDocObject) {
  <div class="col-12">
    <div
      class="row "
      style="border-top:0px solid orange;margin-left:110px"
    >
      <div
        class="col"
        style="padding-left: 0px;padding-right: 0px"
        [ngStyle]="{ 'margin-bottom': editAreaVisible ? '320px' : '80px' }"
      >
        <div class="mt-0 mr-0 ml-0 ">
          <!-- DEBUG LEISTE OBEN   -->
          <div style="border-top:0px solid red; overflow-x: scroll;margin-right: 0px;padding-right: 0px;">
            <div
              id="touchMarkerWrapper"
              style="background-color: red;"
            >
              <div
                id="touchMarker"
                style="background-color: blue;opacity: 0;width: 90%;margin: auto;"
                [ngStyle]="{
                  'max-width': maxzoom +'%',
                  'min-width': minzoom +'%'
                }"
              ></div>
            </div>
            <div
              id="allPagesWrapper"
              style="
            width: 90%;margin: 0px auto"
              [ngStyle]="{
                  'max-width': maxzoom +'%',
                  'min-width': minzoom +'%'
                }"
            >
              @for (pc of pageContexts; track pc; let i = $index) {
              <div class="singleKonvaCanvasWrapper ">
                <app-konva-canvas
                  [editable]="selectedDocObject.metadata.editable"
                  (currentPageChange)="this.selectPage($event)"
                  (imageProceeded)="this.onImageProceeded($event)"
                  [pagesCount]="this.selectedDocObject.metadata.pagescount"
                  [pageContext]="pc"
                  [konvaJson]="konvaJsons[pc.page]"
                  [myUser]="myUser"
                  [bgImage]="this.getPagePreviewUrl(selectedDocObject._id, i, pageContexts[i].timeblockid, pageContexts[i].participantid) | secure | async"
                ></app-konva-canvas>
                <!--
                      [bgImageWatermarkOnly]="this.getPagePreviewUrl(selectedDocObject._id, i, pageContexts[i].timeblockid, pageContexts[i].participantid,true) | secure | async"
                      -->
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="fixed-bottom position-fixed p-0 "
      style="z-index: 1900;"
    >
      @if (allCanvas.length > 0 ) {
      @if (allCanvas?.get(0).pencilMode) {
      <app-konva-paintbox
        [allCanvas]="allCanvas"
        [currentPage]="this._currentPage"
      ></app-konva-paintbox>
      }
      }
      <div
        [appLayout]="layoutService.baseColorSurface"
        style="border:1px solid transparent"
      >
        <table
          cellpadding="0"
          cellspacing="0"
        >
          <tr [appLayout]="layoutService.baseColorSurface">
            <td
              width="1%"
              class="text-nowrap"
              class="text-left"
            >
              <span
                class="d-flex"
                style="position: relative; top: 5px"
              >
                <app-ri-button
                  icon="ri-arrow-left-fill"
                  [disabled]=" this._currentPage * 1 <= 0"
                  (click)="this.scrollTo( this._currentPage-1)"
                >
                </app-ri-button>
                <app-ri-button
                  icon="ri-arrow-right-fill"
                  [disabled]="
                    this._currentPage * 1 + 1 >= selectedDocObject.metadata.pagescount
                  "
                  (click)="this.scrollTo(this._currentPage+1)"
                >
                </app-ri-button>
                <span
                  i18n="@@docPage"
                  class="pl-1 small"
                  style="line-height: 220%"
                >
                  Seite
                </span>
                <input
                  [value]="this._currentPage * 1 + 1"
                  class="text-center small ml-2"
                  style="width: 28px; height: 28px"
                  disabled
                />
                <span
                  i18n="@@docOf"
                  class="px-1 small"
                  style="line-height: 220%"
                >
                  von
                </span>
                <span
                  class="small"
                  style="line-height: 220%"
                >{{
                  selectedDocObject.metadata.pagescount
                  }}</span>
              </span>
            </td>
            <td class="pl-1">
              <span
                class="d-flex"
                style="position: relative; top: 5px"
              >
                <span (click)="zoomOut()">
                  <app-ri-button
                    icon="ri-zoom-out-fill"
                    [disabled]="docZoom == this.minzoom"
                  >
                  </app-ri-button>
                </span>
                <span (click)="zoomIn()">
                  <app-ri-button
                    icon="ri-zoom-in-fill"
                    [disabled]="docZoom == this.maxzoom"
                  >
                  </app-ri-button>
                </span>
              </span>
            </td>
            <td
              class="text-right p-0"
              [ngClass]="{ invisible: !selectedDocObject.metadata.editable }"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="p-0 mr-2 ml-auto"
              >
                <tr>
                  <td>
                    <span
                      i18n="@@docPencil"
                      class="px-1 small text-uppercase"
                    >Stift</span>
                  </td>
                  <td>
                    <label
                      class="switch"
                      style="position: relative"
                    >
                      @if (allCanvas.length > 0) {
                      <input
                        type="checkbox"
                        [ngModel]="allCanvas?.get(0).pencilMode"
                        (ngModelChange)="changePencilMode($event)"
                      />
                      <span class="slider round"></span>
                      }
                    </label>
                  </td>
                </tr>
              </table>
            </td>
            <td
              width="1%"
              class="text-nowrap"
              [ngClass]="{ invisible: !selectedDocObject.metadata.editable }"
            >
              @if (selectedDocObject.metadata.editable) {
              <div
                [appLayout]="layoutService.activeColor"
                class="p-2 text-center"
                (click)="editAreaVisible = !editAreaVisible"
              >
                <span class="d-flex">
                  <i
                    class="ri-message-2-fill mr-2"
                    [appLayout]="layoutService.activeColor"
                    style="
                      -webkit-transform: scaleX(-1);
                      transform: scaleX(-1);
                      position: relative;
                      left: 10px !important;
                    "
                  ></i>
                  @if (!editAreaVisible) {
                  <i class="ri-arrow-up-s-line mr-2"></i>
                  }
                  @if (editAreaVisible) {
                  <i class="ri-arrow-down-s-line mr-2"></i>
                  }
                </span>
              </div>
              }
            </td>
          </tr>
        </table>
      </div>
      <div
        class="row"
        [appLayout]="layoutService.baseColorSurface"
      >
        @if (editAreaVisible) {
        <div class="col-8 offset-2 px-2">
          <div style="background-color: #fff; color: #000; margin: 0px 3px">
            @if (selectedDocObject.metadata.editable) {
            <quill-editor
              class="w-100"
              placeholder=""
              [ngModel]="this.bindedAnnotations[this._currentPage]"
              (ngModelChange)="cbtest($event)"
            >
            </quill-editor>
            } @else {
            <div style="height: 200px">
              <br />
              <h4
                class="text-center"
                i18n="@@docNotesDisabled"
                style="color: #000"
              >
                Notizfunktion ist deaktiviert
              </h4>
            </div>
            }
          </div>
        </div>
        }
        <div></div>
      </div>
    </div>
  </div>
  }
</div>